<template>
  <dx-modal title="Lista de profissionais" :value="true" @input="close">
    <div class="loading loading-lg mt-2" v-if="loading" />
    <template v-else>
      <div class="columns">
        <div class="column col-12 form-group">
          <label class="form-label">Pesquisar</label>
          <div class="input-group">
            <input
              type="text"
              class="form-input"
              id="search"
              v-model="filterSearch"
              v-focus
              placeholder="Digite parte do nome..."
            >
            <button
              class="btn btn-neutral btn-icon btn-action input-group-btn"
              :disabled="loading"
              :class="{loading}"
            ><fa-icon :icon="['fal', 'search']" />
            </button>
          </div>
        </div>
      </div>
      <div class="empty mt-2"
           v-if="data.items.length === 0">
        <div class="empty-icon">
          <fa-icon :icon="['fal', 'info-circle']" size="2x"/>
        </div>
        <p class="empty-title h6">Profissionais</p>
        <p class="empty-subtitle">
          Nenhum profissional cadastrado.
        </p>
      </div>
      <template v-else>
        <div class="empty mt-2"
             v-if="filteredProfessionals.length === 0">
          <div class="empty-icon">
            <fa-icon :icon="['fal', 'info-circle']" size="2x"/>
          </div>
          <p class="empty-title h6">Profissionais</p>
          <p class="empty-subtitle">
            Nenhum profissional encontrado com este nome.
          </p>
        </div>
        <table class="table table-hover">
          <thead>
          <tr>
            <th class="text-secondary" style="width: 40px">
              <label class="form-checkbox">
                <input type="checkbox"
                       @change="selectAllProfessionals"
                       :checked="getProfessionalSelected"
                       :indeterminate.prop="getProfessionalSelected === null">
                <i class="form-icon"></i>
              </label>
            </th>
            <th>Nome</th>
            <th>Conselho</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, i) in filteredProfessionals" :key="i">
            <td class="text-center">
              <label class="form-checkbox">
                <input type="checkbox" v-model="item.selected">
                <i class="form-icon" />
              </label>
            </td>
            <td>
            <span class="hover-link c-hand" @click="selected(item)">
              {{ item.name }}
            </span>
            </td>
            <td>{{ getCouncil(item.council) }}</td>
          </tr>
          </tbody>
        </table>
      </template>
    </template>
    <template v-slot:footer>
      <button
        class="btn btn-primary btn-icon btn-icon-left mr-2"
        v-if="hasSelected"
        @click="addMultiSelected">
        <fa-icon :icon="['fal', 'check-double']" />
        Adicionar selecionados
      </button>
      <button class="btn" @click="close">Sair</button>
    </template>
  </dx-modal>
</template>

<script>
import { mapActions } from 'vuex';
import fuzzy from 'fuzzy';

export default {
  data() {
    return {
      loading: false,
      filterSearch: '',
      data: this.blankData(),
    };
  },
  mounted() {
    this.load();
  },
  computed: {
    hasSelected() {
      return this.data.items.some(({ selected }) => selected);
    },
    getProfessionalSelected() {
      if (this.filteredProfessionals.length === 0) {
        return false;
      }

      const selected = this.filteredProfessionals.filter(item => item.selected);

      if (selected.length === 0) {
        return false;
      }
      if (selected.length === this.filteredProfessionals.length) {
        return true;
      }
      return null;
    },
    filteredProfessionals() {
      let professionals = this.data.items;

      if (this.filterSearch.trim()) {
        const results = fuzzy.filter(this.filterSearch, professionals, {
          extract: (el) => {
            if (el.name) {
              return this.removeAccentuation(el.name);
            }
            return '';
          },
        });
        professionals = results.map(({ original }) => original);
      }

      return professionals;
    },
  },
  methods: {
    ...mapActions({
      apiFetchProfessionals: 'apiFetchProfessionals',
    }),
    close() {
      this.$emit('close');
    },
    load() {
      this.loading = true;
      this.apiFetchProfessionals()
        .then((items) => {
          this.data.items = items.map(item => ({
            selected: false,
            id: item.id,
            name: item.name,
            council: item?.professional?.councils.length > 0
              ? item.professional.councils[0]
              : null,
          }));
        })
        .catch(() => {
          this.$toast.error('Ocorreu um erro ao carregar os dados!');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    selectAllProfessionals(e) {
      this.filteredProfessionals.forEach((item) => {
        item.selected = e.target.checked;
      });
    },
    selected(item) {
      this.$emit('selected', [item]);
    },
    addMultiSelected() {
      this.$emit('selected', this.data.items.filter(({ selected }) => selected));
    },
    getCouncil(council) {
      return `${council?.name}-${council?.state} ${council?.record}`;
    },
    blankData() {
      return {
        items: [],
        hasMore: false,
      };
    },
  },
};
</script>
